export default __webpack_public_path__ + "static/two_body_v2-2c8751d8057508c1c89c0e5fa473d074.png";